if (!customElements.get('related-products')) {
  class ComponentRelatedProducts extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.limit = this.dataset.limit;
      this.html = document.createElement('div');
      this.keenSliderContent = this.querySelector('.keen-slider-content');

      fetch(`/recommendations/products?product_id=${this.productId}&limit=${this.limit}&section_id=related_products_view`)
        .then(response => response.text())
        .then(text => {
          // Load the returned HTML into a temporary container
          this.html.innerHTML = text;
          const related = this.html.querySelector('.related-view');

          if (related && related.innerHTML.trim().length) {
            // 1. Inject the recommendations into the slider container
            this.keenSliderContent.innerHTML = related.innerHTML;

            // 2. Strip off any query params from each recommendation link
            this.keenSliderContent.querySelectorAll('a').forEach(link => {
              link.href = link.href.split('?')[0];
            });

            // 3. Re-attach your quick-view click handlers
            this.keenSliderContent.querySelectorAll('.quick-view-trigger-x').forEach(btn => {
              btn.addEventListener('click', () => {
                const interval = setInterval(() => {
                  const form = document.querySelector('.tingle-modal-box__content #addtocartform');
                  if (form) {
                    form.insertAdjacentHTML(
                      'afterbegin',
                      '<input type="hidden" name="properties[_YMAL-Section]" value="true">'
                    );
                    clearInterval(interval);
                  }
                }, 200);
              });
            });
          }
        })
        .catch(err => {
          console.error('Error loading related products:', err);
        });
    }
  }
  customElements.define('related-products', ComponentRelatedProducts);
}